import { StepsStyleConfig as Steps } from 'chakra-ui-steps';

export const MultiStepComponent = {
  components: {
    Steps,
  },
};
